import { css } from '@emotion/react';
import { semantic_colors, colors, shapes } from '../../foundation';

export const getItemStyle = (isDragging: boolean, style?: React.CSSProperties) => ({
  boxShadow: isDragging ? '0px 4px 16px 0px rgba(0, 0, 0, 0.10)' : undefined,
  ...style,
});

export const item_base_css = css`
  background-color: ${colors.gray10};
  ${shapes.border_radius.small};
`;

export const pin_base_css = css`
  margin: 4px;
  cursor: pointer;
`;

export const getStylesByPinned = (isFixed: boolean) => {
  return isFixed
    ? css`
        path {
          fill: ${semantic_colors.accent.primary};
          transition: all 0.1s linear;
        }
        &:hover {
          path {
            fill: ${colors.blue600};
          }
        }
        &:active {
          path {
            fill: ${colors.blue700};
          }
        }
      `
    : css`
        path {
          fill: ${semantic_colors.content.tertiary};
          transition: all 0.1s linear;
        }
        &:hover {
          path {
            fill: ${semantic_colors.accent.primary};
          }
        }
        &:active {
          path {
            fill: ${colors.blue700};
          }
        }
      `;
};

export const getDraggableStyle = (isDragging: boolean, isDraggingOverlay: boolean, disabled: boolean | undefined) => {
  return css`
    ${shapes.border_radius.small};
    ${isDragging && !isDraggingOverlay && 'opacity: 0;'};
    ${isDraggingOverlay
      ? `
        cursor: grabbing;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
      `
      : `
        cursor: ${disabled ? 'inherit' : 'grab'};
      `};
  `;
};

export const three_bars_base_css = css`
  margin: 4px;
  path {
    fill: ${semantic_colors.content.tertiary};
    transition: all 0.1s linear;
  }
  &:hover {
    path {
      fill: #93939e;
    }
  }
  &:active {
    path {
      fill: #7b7b85;
    }
  }
`;
